<template>
  <Popper
    :placement="placement"
    :openDelay="10"
    @open:popper="$emit('open')"
    @close:popper="$emit('close')"
  >
    <slot></slot>
    <template #content>
      <div class="eval-detail flex-column align-center justify-center">
        <div
          :class="[
            'eval-detail-wrapper',
            {
              'flex-column-reverse': placement.indexOf('top') != -1,
              'flex-column': placement.indexOf('bottom') != -1,
              'flex-row-reverse': placement.indexOf('left') != -1,
              'flex-row reverse': placement.indexOf('right') != -1,
            },
          ]"
        >
          <img
            draggable="false"
            class="arrow"
            src="~@/assets/images/home_pic10_pop@2x.png"
          />
          <div
            :class="[
              'detail-swiper full-parent',
              { loading: loading || !evalDetail },
            ]"
          >
            <loading class="loading" :mask="false" v-if="loading" />
            <div class="eval-detail-info" v-if="!loading && evalDetail">
              <div
                class="
                  code-block
                  flex-row
                  align-center
                  justify-center
                  pointer
                "
                @click="
                  previewImage(null, require('/src/assets/images/mp_qrcode.jpg'))
                "
              >
                <img class="img" src="~@/assets/images/mp_qrcode.jpg" />
                <div class="label">扫码查看更多</div>
              </div>
              <div class="header-item flex-row align-center">
                <img
                  draggable="false"
                  class="header"
                  :src="$filters.formatImage(evalDetail.uheader, 'square')"
                />
                <div class="name">
                  {{ handleUname(evalDetail.uname) || "-" }}·宝妈
                </div>
              </div>
              <div class="header-item flex-row align-center">
                <img
                  draggable="false"
                  class="header"
                  :src="$filters.formatImage(evalDetail.waiterHeader, 'square')"
                />
                <div class="name">{{ evalDetail.waiterName || "-" }}·月嫂</div>
              </div>
              <div class="day">服务天数：{{ evalDetail.serviceDays }}天</div>
              <div class="eval-content">{{ evalDetail.content }}</div>
              <div v-if="evalDetail.imgsUrl" class="image-block flex-row">
                <template
                  v-for="(item, index) of evalDetail.imgsUrl.split(';')"
                  :key="index"
                >
                  <van-image
                    v-if="index < 3"
                    class="img pointer"
                    fit="cover"
                    :src="$filters.formatImage(item)"
                    @click="previewImage(index)"
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Popper>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ImagePreview } from "vant";

export default defineComponent({
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    evalDetail: {
      type: Object,
      default: null
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  },

  methods: {
    previewImage(index: number, url?: string) {
      ImagePreview({
        images: url ? [url] : this.evalDetail.imgsUrl.split(';'),
        startPosition: url ? 0 : index,
        closeable: true
      });
    },
    handleUname(uname: string) {
      if (uname && uname.length > 5) return `${uname.slice(0, 4)}...`;
      else return uname;
    }
  }
})
</script>

<style lang="less" scoped src="./eval-detail.less"></style>
